import Vue from 'vue'
import Vuex from 'vuex'
import addrouters from './modules/addrouters'
import login from './modules/login'
import logoAndIcon from './modules/logoAndIcon'
import order from './modules/order'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    addrouters,
    logoAndIcon,
    login,
    order
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js